/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Fields_Item2Inputs */

const ja_playdata_about_fields_item2 = /** @type {(inputs: Playdata_About_Fields_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントや大会の日程数、ゲームタイトル、スポンサー、主催者、運営/制作者、SNSアカウント情報など`)
};

const en_playdata_about_fields_item2 = /** @type {(inputs: Playdata_About_Fields_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event schedule length, game title, sponsors, organiser, production staff and social account details.`)
};

/**
* | output |
* | --- |
* | "Event schedule length, game title, sponsors, organiser, production staff and social account details." |
*
* @param {Playdata_About_Fields_Item2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_fields_item2 = /** @type {((inputs?: Playdata_About_Fields_Item2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Fields_Item2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_fields_item2(inputs)
	return en_playdata_about_fields_item2(inputs)
});